import type { PreferenciasSesion } from './preferencias';

interface CajoneraProps {
  preferencias: PreferenciasSesion;
  onCambiar: (p: PreferenciasSesion) => void;
}

/**
 * Cajonera de configuración (especificación §4.8; D-14): mostrar
 * transcripción y mostrar avatar, las dos activas por defecto. La opción
 * texto/audio (§4.8.1) queda fuera: el modo texto no está en el contrato.
 */
export function Cajonera({ preferencias, onCambiar }: CajoneraProps) {
  return (
    <section
      id="cajonera-sesion"
      aria-label="Configuración de la entrevista"
      className="space-y-3 border-b border-slate-200 bg-white px-4 py-3 sm:px-6"
    >
      <Interruptor
        etiqueta="Mostrar transcripción"
        activo={preferencias.mostrarTranscripcion}
        onCambiar={(v) => onCambiar({ ...preferencias, mostrarTranscripcion: v })}
      />
      <Interruptor
        etiqueta="Mostrar avatar"
        activo={preferencias.mostrarAvatar}
        onCambiar={(v) => onCambiar({ ...preferencias, mostrarAvatar: v })}
      />
    </section>
  );
}

function Interruptor(props: {
  etiqueta: string;
  activo: boolean;
  onCambiar: (v: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-center justify-between gap-4 text-sm text-slate-700 sm:justify-start">
      <span>{props.etiqueta}</span>
      <button
        type="button"
        role="switch"
        aria-checked={props.activo}
        onClick={() => props.onCambiar(!props.activo)}
        className={`relative h-6 w-11 rounded-full transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 ${
          props.activo ? 'bg-primary-600' : 'bg-slate-300'
        }`}
      >
        <span
          className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${
            props.activo ? 'left-[1.375rem]' : 'left-0.5'
          }`}
        />
      </button>
    </label>
  );
}
